<template>
    <div class="stock-table">
        <input v-model="tableName" placeholder="请输入您的组合名称" class="table-name" style="width: 150px;" />

        <table>
            <thead>
                <tr>
                    <th>股票名称</th>
                    <th>预期每股收益</th>
                    <th>预期每股分红</th>
                    <th>持有股数</th>
                    <th>平均每股购入成本</th>
                    <th>预期每年股票收益</th>
                    <th>股票现金流</th>
                    <th>收益率</th>
                    <th>操作</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(stock, index) in stocks" :key="index">
                    <td><input v-model="stock.name" type="text"></td>
                    <td><input v-model.number="stock.earningsPerShare" type="number"></td>
                    <td><input v-model.number="stock.dividendPerShare" type="number"></td>
                    <td><input v-model.number="stock.shares" type="number"></td>
                    <td><input v-model.number="stock.averageCost" type="number"></td>
                    <td>{{ calculateEarnings(stock) }}</td>
                    <td>{{ calculateCashFlow(stock) }}</td>
                    <td>{{ calculateYield(stock) }}%</td>
                    <td><button @click="removeStock(index)">删除</button></td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="5" style="font-weight: bold;">总计</td>
                    <td>{{ totalEarnings }}</td>
                    <td>{{ totalCashFlow }}</td>
                    <td>{{ totalYield }}%</td>
                    <td>-</td>
                </tr>
            </tfoot>
        </table>

        <div class="button-container">
            <button class="add-btn" @click="addStock">添加新行</button>
            <button class="generate-btn" @click="generateTable">生成表格</button>
        </div>

        <div v-if="showGeneratedTable" class="generated-table">
            <h3>{{ tableName || '未命名表格' }}</h3>
            <table>
                <thead>
                    <tr>
                        <th>股票名称</th>
                        <th>预期每股收益</th>
                        <th>预期每股分红</th>
                        <th>持有股数</th>
                        <th>平均每股购入成本</th>
                        <th>预期每年股票收益</th>
                        <th>股票现金流</th>
                        <th>收益率</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(stock, index) in stocks" :key="index">
                        <td>{{ stock.name }}</td>
                        <td>{{ stock.earningsPerShare }}</td>
                        <td>{{ stock.dividendPerShare }}</td>
                        <td>{{ stock.shares }}</td>
                        <td>{{ stock.averageCost }}</td>
                        <td>{{ calculateEarnings(stock) }}</td>
                        <td>{{ calculateCashFlow(stock) }}</td>
                        <td>{{ calculateYield(stock) }}%</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="5" style="font-weight: bold;">总计</td>
                        <td>{{ totalEarnings }}</td>
                        <td>{{ totalCashFlow }}</td>
                        <td>{{ totalYield }}%</td>
                        <td>-</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StockTable',
    data() {
        return {
            tableName: '',
            stocks: [],
            showGeneratedTable: false
        }
    },
    computed: {
        totalInvestment() {
            return this.stocks.reduce((sum, stock) => {
                return sum + (stock.shares || 0) * (stock.averageCost || 0);
            }, 0);
        },
        totalEarnings() {
            return this.stocks.reduce((sum, stock) =>
                sum + this.calculateEarnings(stock), 0)
        },
        totalCashFlow() {
            return this.stocks.reduce((sum, stock) =>
                sum + this.calculateCashFlow(stock), 0)
        },
        totalYield() {
            if (!this.totalInvestment) return 0;
            return ((this.totalEarnings / this.totalInvestment) * 100).toFixed(2);
        }
    },
    methods: {
        calculateEarnings(stock) {
            return (stock.earningsPerShare || 0) * (stock.shares || 0)
        },
        calculateCashFlow(stock) {
            return (stock.dividendPerShare || 0) * (stock.shares || 0)
        },
        calculateYield(stock) {
            if (!stock.averageCost || stock.averageCost === 0) return 0;
            return ((stock.earningsPerShare || 0) / stock.averageCost * 100).toFixed(2);
        },
        addStock() {
            this.stocks.push({
                name: '',
                earningsPerShare: 0,
                dividendPerShare: 0,
                shares: 0,
                averageCost: 0
            })
        },
        removeStock(index) {
            this.stocks.splice(index, 1)
        },
        generateTable() {
            this.showGeneratedTable = true;
        }
    }
}
</script>

<style scoped>
.stock-table {
    padding: 20px;
    width: 90%;
    overflow-x: auto; /* 添加横向滚动 */
    margin: 0 auto;
    
}

.table-name {
    margin-bottom: 20px;
    padding: 8px;
    font-size: 16px;
}

table {
    min-width: 800px; /* 设置最小宽度确保内容完整显示 */
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
}

th,
td {
    border: 2px solid black;
    padding: 8px;
    text-align: center;
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

input {
    width: 100px;
    height: 30px;
    padding: 4px;
    border-color: red;
}

button {
    padding: 4px 8px;
}

.button-container {
    text-align: center;
    margin: 20px 0;
}

.add-btn, .generate-btn {
    padding: 12px 24px;
    font-size: 16px;
    margin: 0 10px;
    border-radius: 6px;
    font-weight: bold;
    transition: all 0.3s ease;
}

.add-btn:hover, .generate-btn:hover {
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.add-btn {
    padding: 8px 16px;
    background-color: #42b983;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.generate-btn {
    margin-left: 10px;
    padding: 8px 16px;
    background-color: #409eff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.generated-table {
    margin-top: 30px;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 8px;
}

.generated-table h3 {
    margin-bottom: 15px;
    color: #2c3e50;
}

.generated-table table {
    background-color: white;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.generated-table th {
    background-color: #f2f6fc;
}

.generated-table td {
    background-color: white;
}

/* 响应式布局 */
@media screen and (max-width: 768px) {
    .stock-table {
        padding: 10px;
    }

    .table-name {
        width: 100% !important;
        margin-bottom: 10px;
    }

    .button-container {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .add-btn, .generate-btn {
        width: 100%;
        margin: 0;
        padding: 15px;
        font-size: 18px;
    }

    input {
        width: 80px; /* 缩小输入框宽度 */
        font-size: 14px;
    }

    th, td {
        padding: 4px;
        font-size: 14px;
    }
}

/* 针对更小屏幕的优化 */
@media screen and (max-width: 480px) {
    input {
        width: 60px;
        font-size: 12px;
    }

    th, td {
        padding: 2px;
        font-size: 12px;
    }
}
</style>